import { Component, OnInit, Input } from '@angular/core';
import { ExcessProtectService } from '../../excess.service';

@Component({
  selector: 'app-excess-protect-financials',
  templateUrl: './excess-protect-financials.component.html',
  styleUrls: ['./excess-protect-financials.component.css']
})
export class ExcessProtectFinancialsComponent implements OnInit {
  premium: any = '{"referred": null,"ipt": 0,"gross": 0,"breakdown_ipt": 0,"breakdown_gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"breakdown_premiums": {},"vehicle_excesses": {},"driver_excesses": [ ],"compulsory_excess": 0}';
  vehicle_premiums_value: number = 0;
  gross_premium: number = 0;
  commission: number = 0;
  total_amount: number = 0;
  peliwica_fee: number = 0;
  broker_admin_fee: number = 0;
  total_prem_inc_ipt: number = 0;
  ipt: number = 0;
  breakdown_ipt: number = 0;
  quote;
  coverLimitOptions = [];
  constructor(private excessProtectService: ExcessProtectService) { }
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      //this.broker_admin_fee = value.financial_details.broker_admin_fee;
      this.ipt = value.financial_details.ipt_value;
      this.gross_premium = Number(value.financial_details.breakdown_gross);
      this.total_prem_inc_ipt = Number(value.financial_details.breakdown_gross) + Number(value.financial_details.ipt_value);
      this.total_amount = this.total_prem_inc_ipt;
    }
  }
  ngOnInit(): void {
    this.getExcessProtectOptionsList();
  }
  public getExcessProtectOptionsList() {
    // GET UNIQUE ID FOR DRIVERS
    this.excessProtectService.getExcessProtectOptions()
      .subscribe(
        (response: any) => {
          if (response) {
            this.coverLimitOptions = response;
            this.coverLimitOptions = response.result.map(option => ({
              ...option,

            }));
          }
        },
        (error) => { }
      );
  }
  getCoverLimitName(optionId: number): string {
    const option = this.coverLimitOptions?.find(opt => opt.id === optionId);

    if (!option?.name) {
      return '';
    }

    const match = option.name.match(/£([0-9,]+)/);

    return match ? match[1].replace(/,/g, '') : '';
  }
}
